/* istanbul ignore file */
import { useBudgetUrl } from 'domain/shared/budget';
import { useFieldHelper } from 'framework/ui/field';
import { useBudgetService } from 'domain/shared/budget';
import { ButtonWithConfirmation } from 'framework/ui/ui-builder';

interface ArchiveBudgetButtonProps {
  source: string;
  nameSource: string;
  valueSource: string;
  permissionToCheck?: string;
}

const ArchiveBudgetButton = ({ nameSource, valueSource, permissionToCheck, ...props }: ArchiveBudgetButtonProps) => {
  const { getValue } = useFieldHelper(props);
  const { getValue: getName } = useFieldHelper({ source: nameSource });
  const { getValue: getIsArchived } = useFieldHelper({ source: valueSource });
  const isArchived = getIsArchived();
  const { getListUrl } = useBudgetUrl();
  const { archive } = useBudgetService();

  const archiveAction = async () => {
    return archive(getValue() as any, !isArchived);
  };

  return (
    <ButtonWithConfirmation
      afterSubmit={{
        redirectUrl: getListUrl(),
        successMessage: `${getName()} was ${isArchived ? 'restored' : 'archived'}`,
        errorMessage: `${getName()} can not ${isArchived ? 'restored' : 'archived'}`,
      }}
      modalConfirmButtonText={isArchived ? 'Restore' : 'Archive'}
      submitMethod={archiveAction}
      permissionToCheck={permissionToCheck}
      color={isArchived ? 'success' : 'secondary'}
      displayMessage={`Do you really want to ${isArchived ? 'restore' : 'archive'} the budget?`}
      variant="outlined"
    >
      {isArchived ? 'Restore' : 'Archive'}
    </ButtonWithConfirmation>
  );
};

export default ArchiveBudgetButton;
